<template>
    <carousel class="row" v-if="newsAttachmentsData"
    :autoplay="false"
    :perPage="1"
    :navigationEnabled="true"
    :paginationSize="6"
    :paginationEnabled="true"
    >
        <slide :class="[{'VueCarousel-slide-active': index === 0},'news col-12 ']"   v-for="(newss, index) in news" :key="index">
            <div>
                <h3>{{newss.attributes.field_categoria}}</h3>
                <h4>{{newss.attributes.title}}</h4>
                <p v-html="newss.attributes.field_description.processed"></p>
                <p v-if="newss.attachment"><a class="attachment" target="_blank" :href="'https://ptnlex-api-prod.interfase.tv/'+newss.attachment.data.attributes.uri.url">{{newss.attachment.data.attributes.filename}}</a></p>
              </div>
        </slide>
    </carousel>
    <div v-else>loading</div>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'news',
    components: {
        Carousel,
        Slide
    },
    props: {
        dataNews: {
            type: String
        }
    },
    data:()=>{
            return {
                newsData:[],
                newsAttachmentsData:[],
            }
    },
    computed:{
        news(){
            return this.newsData
        },
    },
    methods:{
        mergeAttachments(){
            this.newsData.forEach((n,index) => {
                if(n.relationships.field_attachment.data){
                    n['attachment'] = this.newsAttachmentsData;
                }
            });
        },
        fetchAttachments(u){
            fetch(u, {method: "GET", mode: 'cors'})
                .then(response=>{
                    return response.json()
                })
                .then(json=>{
                    this.newsAttachmentsData = json
                    if(this.newsAttachmentsData){
                        this.mergeAttachments();
                    }
                })  
                .catch(function(error) {  
                    console.log('Request failed', error)  
                });
        },
    },
    created(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/news", {method: "GET", mode: 'cors'})
            .then(response=>{
                return response.json()
            })
            .then(json=>{
                console.log(json);
                json.data.forEach(e => {
                    if(e.relationships.field_attachment.data!=null) {
                        this.fetchAttachments(e.relationships.field_attachment.links.related.href)
                    }
                });
                this.newsData = json.data
            })
            .catch(function(error) {  
                console.log('Request failed', error)  
            });
    }
}
</script>

<style lang="scss">
.section.news{
.news{
        padding: 0px 9rem 0px 1rem;
        .attachment{
            color: #1B1B19;
            text-decoration: underline;
            position: relative;
            padding: 21px 46px 6px 46px;
            display: block;
            border-top: 1px solid #cecece;

            &:empty{
                display: none;
            }

            &:before{
                position: absolute;
                background: url("../assets/icon-attachment.png") center;
                background-size: cover;
                width: 34px;
                content: "";
                display: block;
                height: 34px;
                top: 20px;
                left: 0;
            }
        }

p p {
    margin-bottom: 4rem;
    column-count: 3;
    column-gap: 2rem;
}
h3 {
    color: #fff;
    font-size: 400;
    font-size: 0.75rem;
    margin-bottom: 6px;
}

  h4 {
        font-size: 1.125rem;
        width: calc(33.3% - 1rem);
    }
}
.VueCarousel-wrapper {
    overflow: visible;
}
.VueCarousel-slide {
    transition: 0.3s ease;
     opacity: 0.2;
}
.VueCarousel-slide-active{
    opacity: 1;
    transition: 0.3s ease;
}
}

.news .VueCarousel-navigation-button.VueCarousel-navigation-prev,
.news .VueCarousel-navigation-prev,
.news .VueCarousel-navigation-button.VueCarousel-navigation-prev {
    color: transparent ;
    top:100%;
}
.news .VueCarousel-navigation-button.VueCarousel-navigation-next {
    color: transparent;
    top:100%;
    &:after {
        position: absolute;
        display: block;
        color: #14182e;
        font-size: 0.825rem;
        top: 40px;
        left: 1px;
        display: none;
    }
    &:before {
        position: absolute;
        background: url("../assets/arrow-carousel.png") center;
        background-size: cover;
        width: 121px;
        content: "";
        display: block;
        height: 33px;
        top: 0;
        left: 0;
    }
}
.VueCarousel-navigation--disabled {
    opacity: 0 !important;
    cursor: auto !important;
}
.news .VueCarousel-navigation-button.VueCarousel-navigation-prev {
    color: transparent;
    top:100%;
    &:after {
        position: absolute;
        display: block;
        color: #14182e;
        font-size: 0.825rem;
        top: 40px;
        left: 1px;
        display: none;
    }
    &:before {
        position: absolute;
        background: url("../assets/arrow-carousel.png") center;
        background-size: cover;
        transform-origin: center;
        transform: rotate(180deg);
        width: 121px;
        content: "";
        display: block;
        height: 33px;
        top: 0;
        left: 0;
    }
}
html:lang(it) {
    .VueCarousel-navigation-button.VueCarousel-navigation-next {
        &:after {
            
            content: "prossimo";
        }
    }
}
html:lang(en) {
    .VueCarousel-navigation-button.VueCarousel-navigation-next {
        &:after {
            content: "neeeext";
        }
    }
}

/*
    
*/

@media (max-width:1500px){
    .VueCarousel-navigation-button.VueCarousel-navigation-next {
        right: 220px;
    }
}

@media (max-width:992px){
    .VueCarousel-navigation-button.VueCarousel-navigation-next{
        display: none;
    }
    .section.news{
            .news {
                padding: 0px 5rem 0px 1rem;

                h4 {
                    width: 100%;
                }
                p p {
                    margin-bottom:4rem;
                    column-count: 1;
                }
        }      
    }
}

@media (max-width:768px) {
    .section.news .news {
        padding: 0px 0rem 0px 1rem;
    }
}

</style>
